import { render, staticRenderFns } from "./mitra-kurir-mobil.vue?vue&type=template&id=530cb56a&scoped=true"
import script from "./mitra-kurir-mobil.vue?vue&type=script&lang=js"
export * from "./mitra-kurir-mobil.vue?vue&type=script&lang=js"
import style0 from "./mitra-kurir-mobil.vue?vue&type=style&index=0&id=530cb56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530cb56a",
  null
  
)

export default component.exports